import React from 'react'
import { Routes, Route } from 'react-router-dom'

import { RegistrationContainer } from '../../components/RegistrationContainer'
import { PaginationProvider } from '../../contexts/PaginationContext'
import { useBreadcrumb } from '../../hooks/useBreadcrumb'

import { SignaturesTable, SignatureForm } from './components'

export const Signatures: React.FC = () => {
  const breadcrumb = useBreadcrumb({
    assinaturas: 'Assinaturas',
    inclusao: 'Inclusão',
    edicao: 'Edição'
  })

  return (
    <RegistrationContainer breadcrumbItems={breadcrumb}>
      <PaginationProvider>
        <Routes>
          <Route path="/" element={<SignaturesTable />} />
          <Route path="/inclusao" element={<SignatureForm />} />
          <Route path="/edicao" element={<SignatureForm />} />
        </Routes>
      </PaginationProvider>
    </RegistrationContainer>
  )
}
